export const footerTranslations = {
  en: {
    footer: {
      connect: "Connect With Us",
      tools: "Financial Tools",
      company: "Company",
      about: "About Us",
      pricing: "Pricing",
      contact: "Contact",
      legal: "Legal",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      allRightsReserved: "All rights reserved",
      comingSoon: "Coming Soon",
    },
  },
  es: {
    footer: {
      connect: "Conéctate con Nosotros",
      tools: "Herramientas Financieras",
      company: "Empresa",
      about: "Sobre Nosotros",
      pricing: "Precios",
      contact: "Contacto",
      legal: "Legal",
      terms: "Términos de Servicio",
      privacy: "Política de Privacidad",
      cookies: "Política de Cookies",
      allRightsReserved: "Todos los derechos reservados",
      comingSoon: "Próximamente",
    },
  },
  de: {
    footer: {
      connect: "Verbinden Sie Sich Mit Uns",
      tools: "Finanztools",
      company: "Unternehmen",
      about: "Über Uns",
      pricing: "Preisgestaltung",
      contact: "Kontakt",
      legal: "Rechtliches",
      terms: "Nutzungsbedingungen",
      privacy: "Datenschutzrichtlinie",
      cookies: "Cookie-Richtlinie",
      allRightsReserved: "Alle Rechte vorbehalten",
      comingSoon: "Bald",
    },
  },
  fr: {
    footer: {
      connect: "Connectez-vous Avec Nous",
      tools: "Outils Financiers",
      company: "Entreprise",
      about: "À Propos de Nous",
      pricing: "Tarifs",
      contact: "Contact",
      legal: "Légal",
      terms: "Conditions d'Utilisation",
      privacy: "Politique de Confidentialité",
      cookies: "Politique de Cookies",
      allRightsReserved: "Tous droits réservés",
      comingSoon: "Bientôt",
    },
  },
  hi: {
    footer: {
      connect: "हमसे जुड़ें",
      tools: "वित्तीय उपकरण",
      company: "कंपनी",
      about: "हमारे बारे में",
      pricing: "मूल्य निर्धारण",
      contact: "संपर्क करें",
      legal: "कानूनी",
      terms: "सेवा की शर्तें",
      privacy: "गोपनीयता नीति",
      cookies: "कुकी नीति",
      allRightsReserved: "सर्वाधिकार सुरक्षित",
      comingSoon: "जल्द ही",
    },
  },
};
